import './ThankYou.css';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import parse from "html-react-parser";
import { useScrollToTop } from '../../lib/hooks';
import { useAppContext } from '../../lib/contexts';

function ThankYouLenderList() {
  const { state } = useLocation();
  const pixel = state?.pixel;
  const status = state?.status;

  const { appContext, isAppContextReady } = useAppContext();

  useScrollToTop();
  useEffect(() => {
    if (!isAppContextReady) return;

    const {
      publisher_id,
      subid,
      cake,
    } = appContext;

    const params = new URLSearchParams(window.location.search);
    const persistedParams = JSON.parse(localStorage.getItem("redirectParams")) || {};

    if (publisher_id) params.set('publisher_id', publisher_id);
    if (subid) params.set('subid', subid);
    if (cake) params.set('cake', cake);

    const newUrl = `${window.location.pathname}?${params.toString()}`;

    window.history.replaceState(null, '', newUrl);
  }, [appContext, isAppContextReady]);

  useEffect(() => {
    const script = document.createElement('script');
    script.src =
      'https://cdn.myadoptimizer.com/maojsfiles/landingpagesjs/2f739c29-e650-4202-877a-f9624cb5bd9f.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <>
      {pixel && <div>{parse(pixel)}</div>}

      <section id="thankYouFirstSection">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 text-center">
                <span>Your Offer Is On Its Way — Expect a Call Shortly!</span>
            </div>
          </div>
        </div>
      </section>

      <div id="target" className="container my-4" />
    </>
  );
}

export default ThankYouLenderList;
